<script>
    import MainTitle from "./MainTitle.svelte";

</script>

<header id="header" class="section">    

    <div class="container box valign-wrapper">
        <MainTitle/>
    </div> 
</header>

<style>
    #header{background-color: transparent !important;}
    .container.box{
        height: 50vh;
        min-height: 350px;
        justify-content: center;
    }
</style>